const SeparatorSubmenu = () => {
    return (
      <div className='separator-submenu'>........................</div>
    );
};

export default SeparatorSubmenu;
